export function separateStrings(mainString: string, searchString: string, item) {
  if (!searchString) {
      return [mainString]
  }
  const parts = mainString.split(new RegExp(`(${searchString})`, 'gi'));
  return parts
}